import Nullstack from 'nullstack';
export default function IconRouter({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-router",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("rect", {
    x: "3",
    y: "13",
    width: "18",
    height: "8",
    rx: "2"
  }), "   ", Nullstack.element("line", {
    x1: "17",
    y1: "17",
    x2: "17",
    y2: "17.01"
  }), "   ", Nullstack.element("line", {
    x1: "13",
    y1: "17",
    x2: "13",
    y2: "17.01"
  }), "   ", Nullstack.element("line", {
    x1: "15",
    y1: "13",
    x2: "15",
    y2: "11"
  }), "   ", Nullstack.element("path", {
    d: "M11.75 8.75a4 4 0 0 1 6.5 0"
  }), "   ", Nullstack.element("path", {
    d: "M8.5 6.5a8 8 0 0 1 13 0"
  }), " ");
}